<ng-container>

	<mat-card (cdkDragEnded)="_dragEnd($event);" (mousedown)="_mouseDown($event);" [cdkDragFreeDragPosition]="position" [ngStyle]="_visible()" cdkDrag cdkDragBoundary=".desktop" class="drag-box patter-table panel">
		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button id="mat-clear-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>
		<mat-card-content [ngStyle]="styleSize(10 + this.size[0] + 'px')" class="panel-content" fxLayout="row">
			<div *ngIf="locked" cdkDragHandle></div>

			<div fxLayout="row wrap">
				<img *ngFor="let phase of shotphases" [src]="phaseToImage(phase)" fxFlex="33" style="padding:4px" alt="">
			</div>

			<ng-template #noData>
				<mat-card style="background-color:#cdcdcd;">
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>

</ng-container>


